import axios from "axios";
import qs from 'qs'
import $store from "../store"

let baseUrl = 'https://apiv8.fx8988.com' //process.env.VUE_APP_BASE_URL //
// let baseUrl = 'http://apiv7.fx8988.com'
// let baseUrl = 'http://150.107.3.11:8176'
// let baseUrl = 'http://127.0.0.1:8000'
let baseAPIUrl = baseUrl + '/apivc/'
axios.defaults.timeout = 50000
axios.defaults.baseURL = baseAPIUrl
axios.defaults.withCredentials = false

export function api_url(){
    return {
        imgBaseUrl: baseUrl,
        news_list: 'news_list',
        news_class: 'news/getlist',
        news_info: 'news/getinfo',
        free: 'free',
        match_list: 'match_list',
        search: 'search',
        match_list_more: 'match_list_more',
        dan_list: 'dan_list',
        coupon_list: 'coupon_list',
        expert_list: 'expert_list',
        expert_info: 'expert_info',
        expert_rate: 'expert_getrate',
        match_view: 'match_view',
        match_get: 'match_get',

        login: 'authen/login',
        register: 'authen/register',
        dingyue: 'commonck/recommend-subscribe', //立即订阅(弹窗确认)
        dingyue_submit: 'commonck/recommend-submit', //立即订阅
        sign: 'commonck/sign',
        getCoupon: 'commonck/getcoupon',
        getUserInfo: 'commonck/getUserInfo',

        member_upnick: 'commonck/update-nick',
        member_uppwd: 'commonck/update-pwd',
        member_getusdt: 'commonck/getusdt',
        member_getpaytre: 'commonck/getpaytre',
        member_getpaytre_status: 'commonck/getpaytre-status',
        member_cost_action: 'commonck/cost-action',
        member_cost_delete: 'commonck/cost-delete',
        member_scribe_action: 'commonck/subscribe-action',
        member_scribe_delete: 'commonck/subscribe-del',
        member_coupon_delete: 'commonck/coupon-action',
        member_payInfo:'commonck/payInfo',
        addcart: 'commonck/cart-add',
        cartDelDg: 'commonck/cart-delete',
        cartDelPl: 'commonck/cart-delete-pl',
        cartClearOver: 'commonck/cart-clear',
        cartsubmit: 'commonck/cart-submit',

        cart_list: 'commonek/cart_list',
        memberinfo: 'commonek/account/info',
        member_subscribe: 'commonek/account/subscribe',
        member_coupon:'commonek/account/coupon',
        member_cost:'commonek/account/cost',

    }
}
/**
 * post方法，对应post请求
 * @param {String} url [请求的url地址]
 * @param {Object} params [请求时携带的参数]
 */
export function post(showLoading= true, url, params = {}){
    let that = this
    if(typeof showLoading == 'string'){
        params = url
        url = showLoading
        showLoading = true
        if(params === undefined)
            params = {}
    }
    // console.log(showLoading)
    // console.log(url)
    // console.log(params)
    return new Promise((resolve, reject) => {
        let token = that.$store.state.token
        // if(token === null || token === '' || token === undefined){
        //     that.$store.commit('SHOW_LOGINPOP')
        //     return
        // }
        axios.defaults.headers['token'] = token  //token放在此处意味着可以实时读取最新的
        let timeout = 0

        if(showLoading) {
            that.$toast.loading({message: '请稍后...', duration: 0, forbidClick: true})
            timeout = 10
        }
        if(url===undefined){
            url = showLoading
        }
        setTimeout(function () {
            axios.post(url, qs.stringify(params)).then(response => {
                // console.log(response.data)
                // console.log(that.$router)
                if(showLoading)
                    that.$toast.clear()
                if(response.data.code === 1002){
                    that.$store.commit('LOGOUT')
                    that.$store.commit('SHOW_LOGINPOP')
                }
                else {
                    resolve(response.data)
                }
            }, err=>{
                // if(showLoading)
                //     that.$toast.clear()
                reject(err)
                // that.$toast.fail('请求失败~')
            })
        }, timeout)
    })
}
/**
 * get方法，对应get请求
 * @param {String} url [请求的url地址]
 * @param {Object} params [请求时携带的参数]
 */
export function get(url, params = {}){
    let that = this
    // console.log(that.$route.meta.auth)
    return new Promise((resolve, reject) => {
        axios.defaults.headers['token'] = $store.state.token  //token放在此处意味着可以实时读取最新的
        axios.get(url, {params:params}).then(response => {
            if(response.data.code === 1002){
                that.$store.commit('LOGOUT')
                that.$router.replace({path: '/login'})
            }
            else if(response.data.code === 1005){
                that.$router.replace({path: '/error'})
            }
            else {
                resolve(response.data)
            }
        }, err=>{
            // that.$toast.fail('reuqest fail~')
            reject(err)
        })
    })
}
